module.exports = __webpack_public_path__ + "img/img-wap.1071ede0.png";